import { Helmet } from 'react-helmet-async';
import React from 'react';
import ChangeInsightEditContainer from '../../containers/change-insights/ChangeInsightEditContainer.jsx';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

const ChangeInsightEdit = ({ slug, initiativeId, initiativeType }) => (
  <>
    <Helmet>
      <title>Edit Feedback Form Template | ChangeSync</title>
    </Helmet>
    <ChangeInsightEditContainer
      slug={slug}
      edit
      initiativeId={initiativeId}
      initiativeType={initiativeType}
    />
  </>
);

export default requireAuth(withRouterParams(ChangeInsightEdit));
